import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ButtonCounter, { SIZE } from '@components/ButtonCounter';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0;
`;

function QuantityCounter({
  quantity,
  productMaxQuantity,
  onChangeLimitQuantity,
  onChangeQuantity,
  className,
}) {
  return (
    <Container>
      <ButtonCounter
        className={className}
        onChangeQuantity={
          productMaxQuantity ? onChangeLimitQuantity : onChangeQuantity
        }
        quantity={quantity}
        size={SIZE.SMALL}
      />
    </Container>
  );
}

QuantityCounter.propTypes = {
  quantity: PropTypes.number.isRequired,
  productMaxQuantity: PropTypes.number,
  onChangeLimitQuantity: PropTypes.func.isRequired,
  onChangeQuantity: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default QuantityCounter;
